import { createContext, useState } from 'react';

export const ExpiredProductContext = createContext();
export const ExpiredProductProvider = ({ children }) => {
    const [isCreatedExpiredProduct, setIsCreatedExpiredProduct] = useState(null);
    const [isEditedExpiredProduct, setIsEditedExpiredProduct] = useState(null);
    const [isDeletedExpiredProduct, setIsDeletedExpiredProduct] = useState(null);
    const [selectedExpiredProduct, setSelectedExpiredProduct] = useState(null);
    const [selectedStoredId, setSelectedStoredId] = useState(null);
    const [expiredproductIds, setExpiredProductIds] = useState([]);
    const [researchExpiredProducts, setResearchExpiredProducts] = useState([]);
    const [isMoreInformation, setIsMoreInformation] = useState(false);

    const [isStoresChecked, setIsStoresChecked] = useState(true);
    const [isUsersChecked, setIsUsersChecked] = useState(true);
    const [isProductNameChecked, setIsProductNameChecked] = useState(true);
    const [isManufacturerChecked, setIsManufacturerChecked] = useState(true);
    const [isLotChecked, setIsLotChecked] = useState(true);
    const [isExpirationDateChecked, setIsExpirationDateChecked] = useState(true);
    const [isDaysToExpireChecked, setIsDaysToExpireChecked] = useState(true);
    const [isGroupChecked, setIsGroupChecked] = useState(true);
    const [isQuantityChecked, setIsQuantityChecked] = useState(true);
    const [isQuantitySoldChecked, setIsQuantitySoldChecked] = useState(true);
    const [isBalanceChecked, setIsBalanceChecked] = useState(true);
    const [isStatusProductChecked, setIsStatusProductChecked] = useState(true);
    const [isFilter, setIsFilter] = useState(false);
    const [filterData, setFilterData] = useState([]);
    const [isTransferred, setIsTransferred] = useState(false);
    const [expiredFilteredProducts, setExpiredFilteredProducts] = useState([]);
    
    const addExpiredProduct = ( value ) => { setIsCreatedExpiredProduct(value) };
    const editExpiredProduct = ( value ) => { setIsEditedExpiredProduct(value) };
    const clearExpiredProduct = () => {
        setIsCreatedExpiredProduct(null);
        setIsDeletedExpiredProduct(null)
        setIsEditedExpiredProduct(null)
        setSelectedExpiredProduct(null)
        setIsTransferred(null)
    }
    const clearFilterState = () => {
        setIsFilter(false)
    }
    const clearMoreInformation = () => {
        setIsMoreInformation(false)
    }
    const setExpiredProduct = ( expiredProduct ) => { 
        setSelectedExpiredProduct( expiredProduct )
    }
    return (
        <ExpiredProductContext.Provider value={{ 
            isCreatedExpiredProduct, 
            addExpiredProduct, 

            selectedExpiredProduct,
            setExpiredProduct,
            
            isDeletedExpiredProduct,
            setIsDeletedExpiredProduct,

            isEditedExpiredProduct,
            editExpiredProduct,

            selectedStoredId, 
            setSelectedStoredId,
            clearExpiredProduct,

            expiredproductIds,
            setExpiredProductIds,

            researchExpiredProducts,
            setResearchExpiredProducts,

            isStoresChecked, setIsStoresChecked,
            isUsersChecked, setIsUsersChecked,
            isProductNameChecked, setIsProductNameChecked,
            isManufacturerChecked, setIsManufacturerChecked,
            isLotChecked, setIsLotChecked,
            isExpirationDateChecked, setIsExpirationDateChecked,
            isDaysToExpireChecked, setIsDaysToExpireChecked,
            isGroupChecked, setIsGroupChecked,
            isQuantityChecked, setIsQuantityChecked,
            isQuantitySoldChecked, setIsQuantitySoldChecked,
            isBalanceChecked, setIsBalanceChecked,
            isStatusProductChecked, setIsStatusProductChecked,
            isFilter, 
            setIsFilter, 
            clearFilterState, 
            filterData, 
            setFilterData,

            isMoreInformation,
            setIsMoreInformation,
            clearMoreInformation,

            isTransferred, 
            setIsTransferred,

            expiredFilteredProducts, 
            setExpiredFilteredProducts
         }}>
            {children}
        </ExpiredProductContext.Provider>
    );
};
